import { suppliesStoreConstants } from './constants';
import { shopifyAxios } from './shopify-axios';
import { stripShopifyIdPrefix } from './shopify-id-utils';

type CheckoutCreateResponse = {
  data: {
    cartCreate: {
      cart: {
        id: string;
        checkoutUrl: string;
      };
      userErrors: Array<{
        code: string;
        field: string[];
        message: string;
      }>;
    };
  };
  errors?: Array<{ message: string }>;
};

type CheckoutResult = {
  checkoutId: string;
  checkoutUrl: string;
};

export const createCheckout = async (variantId: string): Promise<CheckoutResult> => {
  const returnUrl = `${window.location.origin}/supplies?checkout=success`;

  const variables = {
    input: {
      lines: [
        {
          merchandiseId: variantId,
          quantity: 1,
        },
      ],
      attributes: [
        {
          key: '_return_url',
          value: returnUrl,
        },
      ],
    },
  };

  const response = await shopifyAxios.post<CheckoutCreateResponse>(
    suppliesStoreConstants.SHOPIFY_GRAPHQL_URL,
    { query: suppliesStoreConstants.CREATE_CHECKOUT_MUTATION, variables },
    { headers: { 'Content-Type': 'application/json' } },
  );

  if (response.data.errors) {
    throw new Error(`GraphQL Error: ${JSON.stringify(response.data.errors)}`);
  }

  const { cart, userErrors } = response.data.data.cartCreate;

  if (userErrors.length > 0) {
    throw new Error(`Cart Error: ${JSON.stringify(userErrors)}`);
  }

  if (!cart) {
    throw new Error(`Cart Error: ${JSON.stringify(cart)}`);
  }

  return {
    checkoutId: stripShopifyIdPrefix(cart.id),
    checkoutUrl: cart.checkoutUrl,
  };
};
